import * as React from 'react'

import { Button, Input } from '@buffer-mono/popcorn'

import AppActionCreators from '../action-creators/AppActionCreators'
import { NotificationScopes } from '../AppConstants'
import NotificationContainer from './NotificationContainer'
import NotificationActionCreators from '../action-creators/NotificationActionCreators'
import type { ComposerProfile, Subprofile } from '../stores/types'
import type { Notification } from '../values/Notification'

import styles from './css/BoardCreator.module.css'

interface BoardCreatorProps {
  subprofiles?: Subprofile[]
  profile: ComposerProfile
  visibleNotifications: Notification[]
}

interface BoardCreatorState {
  boardName: string
}

class BoardCreator extends React.Component<
  BoardCreatorProps,
  BoardCreatorState
> {
  constructor(props: BoardCreatorProps) {
    super(props)
    this.state = this.getInitialBoardCreatorState()
  }

  onSubmit = (e: React.FormEvent): void => {
    e.preventDefault()
    const notifications = this.props.visibleNotifications.filter(
      (notif) => notif.scope === NotificationScopes.BOARD_CREATION,
    )
    for (const notification of notifications) {
      NotificationActionCreators.removeNotification(notification.id)
    }

    const { boardName } = this.state
    const profileId = this.props.profile.id

    AppActionCreators.createNewSubprofile(profileId, boardName)

    this.setState(this.getInitialBoardCreatorState())
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      boardName: e.target.value,
    })
  }

  getInitialBoardCreatorState = (): BoardCreatorState => ({
    boardName: '',
  })

  render(): JSX.Element {
    const { isSubprofileCreationPending } = this.props.profile.appState
    const isBoardNameEmpty = this.state.boardName.length === 0

    const isDisabled = isBoardNameEmpty || isSubprofileCreationPending
    const submitButtonLabel = isSubprofileCreationPending
      ? 'Creating…'
      : 'Create'

    const visibleNotificationsForProfile =
      this.props.visibleNotifications.filter(
        (notif) => notif.data?.profileId === this.props.profile.id,
      )

    return (
      <div className={styles.createNewBoard}>
        <form onSubmit={this.onSubmit} className={styles.createBoardForm}>
          <Input
            value={this.state.boardName}
            placeholder="New board name"
            onChange={this.onChange}
          />
          <Button type="submit" disabled={isDisabled}>
            {submitButtonLabel}
          </Button>
        </form>
        <NotificationContainer
          visibleNotifications={visibleNotificationsForProfile}
          scope={NotificationScopes.BOARD_CREATION}
        />
      </div>
    )
  }
}

export default BoardCreator
